module.exports = __webpack_public_path__ + "static/img/SmileAnimation_orange.04deddc.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/SmileAnimation_orange.gif
// module id = Swnb
// module chunks = 0